// extracted by mini-css-extract-plugin
export var brand = "_39-8";
export var compact = "_39-5";
export var extraSmall = "_39-6";
export var icon = "_39-0";
export var large = "_39-3";
export var light = "_39-1";
export var medium = "_39-4";
export var outline = "_39-a";
export var primaryDark = "_39-9";
export var primaryLight = "_39-7";
export var primaryModern = "_39-b";
export var success = "_39-2";